module.exports = __webpack_public_path__ + "static/media/plan-acumula-400gb.2594bc2f.svg";